<template>
  <div :class="s.aboutCentent">
    <div :class="s.nav">
      <div :class="s.navHeader">
        <img :src="require('../images/aboutText.png')" alt="" />
      </div>
      <div :class="s.navBar">
        <div
          :class="[s.navSingle, { [s.heighLight]: index === selected }]"
          v-for="(item, index) in navs"
          :key="index"
          @click="changeSelect(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div :class="s.textBox">
      <h3 v-html="textBox[selected].title"></h3>
      <div
        :class="s.indent"
        v-html="textBox[selected].content"
        v-if="selected !== 2"
      ></div>
      <p v-else><PublicInfo /></p>
    </div>
  </div>
</template>

<script>
import { CULTUREE, LETTER } from "./text.js";
import PublicInfo from "./PublicInfo.vue";
const textBox = [
  {
    title: "COMPANY PROFILE<br/>公司简介",
    content: `<p>上海妙保保险经纪股份有限公司（以下简称“妙保经纪”），原名上海同人保险经纪股份有限公司，成立于2010年07月09日，是由中国保险监督管理委员会（以下简称“保监会”）批准成立的一家集寿险、财险为一体，面向个人客户、企业客户进行全方位综合性保险咨询、个性化保险配置和服务的专业化保险经纪机构。</p>
      <p>2018年北京妙医佳健康科技集团（以下简称“妙健康”）收购上海同人保险经纪99.140625%的股权。妙健康收购同人后，对同人的业务进行重组，并成立妙保事业部进行管理（妙保的寓意More Insure ，More Health），同人经纪规模迎来大发展。2019年8月28日妙健康发布科技保险平台“妙保”，并正式推出“保险用户健康管理平台”、“智能核保系统”两个平台计划，此外，妙保品牌还联合保险行业合作伙伴推出“抗压卫士”高血压关怀计划、“粉红斗士”乳腺癌术后关怀计划、“糖医战士”糖尿病关怀计划三款慢病关怀计划。2020年12月上海同人保险经纪更名为上海妙保保险经纪股份有限公司。</p>`
  },
  {
    title: "ENTERPRISE CULTUREE<br/>企业文化",
    content: CULTUREE
  },
  {
    title: "PUBLIC INFO<br/>公开信息披露",
    content: PublicInfo
  },
  {
    title: "LEADERSHIP SPEECH<br/>领导致辞",
    content: LETTER
  },

  {
    title: "ORGANIZATION STRUCTURE<br/>组织构架",
    content: `<img src="${require("../images/zhpic.gif")}" />`
  }
  // {
  //   title: "资质证书",
  //   content: `<img src="${require("../images/license.png")}" style="width:700px" /><br/><img src="${require("../images/promission.png")}" style="width:700px" />`,
  // },
];
const navs = [
  "·Company 公司介绍·",
  "·Culture 企业文化·",
  "·Public 公开信息披露·",
  "·Speech 领导致辞·",
  "·Organization 组织架构·"
  // "·资质证书·",
];
export default {
  computed: {
    s() {
      return this.$style;
    }
  },
  components: {
    PublicInfo
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.$nextTick(() => {
          //   this.selected = this.$route.query.selected || 0;
          this.changeSelect(~~this.$route.query.selected - 1);
        });
      },
      // 深度观察监听
      deep: true
    }
  },
  data() {
    return {
      selected: 0,
      navs,
      textBox
    };
  },

  mounted() {
    // this.$nextTick(() => {
    //   //   this.selected = this.$route.query.selected || 0;
    //   this.changeSelect(~~this.$route.query.selected || 0);
    // });
    setTimeout(() => {
      this.changeSelect(~~this.$route.query.selected - 1 || 0);
    }, 500);
  },
  methods: {
    changeSelect(index) {
      this.selected = index;
    }
  }
};
</script>

<style scoped lang="less" module>
.aboutCentent {
  //   height: 1024px;
  overflow: hidden;
  position: relative;
}

.nav {
  position: absolute;
  left: 0;
  top: 110px;
  border-radius: 0 30px 30px 0;
  overflow: hidden;
  box-shadow: 5px 5px 5px #eee;
}
.navHeader {
  width: 300px;
  height: 105px;
  //   background-color: #00468c;
  display: flex;
  align-items: center;
  margin-bottom: -2px;
}
.navSingle {
  width: 300px;
  height: 58px;
  line-height: 58px;
  background-color: #fff;
  color: #9b9b9b;
}
.heighLight {
  background-color: #1669bc;
  color: #fff;
}
.textBox {
  //   width: 1075px;
  margin: 178px 344px 10px;
  padding: 30px 60px 30px;
  box-sizing: border-box;
  box-shadow: 0px 5px 5px 5px #eee;
  text-align: left;
  min-width: 750px;
  h3 {
    font-size: 20px;
    color: #1669bc;
  }
  .indent {
    font-size: 20px;
    line-height: 30px;
    text-indent: 2em;
  }
  font {
    margin-left: -2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/Content.vue